import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { InvoiceData } from './invoiceManagedInterface';


interface InvoiceDataSlice {
  data: InvoiceData;
}

interface InvoiceState {
  data: InvoiceDataSlice | null;
}

const initialState: InvoiceState = {
  data: null,
};

export const invoiceSlice = createSlice({
  name: 'invoiceManaged',
  initialState,
  reducers: {
    saveInvoiceManagedData: (state, action: PayloadAction<InvoiceDataSlice>) => {
      state.data = action.payload;
    },
    clearInvoiceManagedData: (state) => {
      state.data = null;
    },
  },
});

export const { saveInvoiceManagedData, clearInvoiceManagedData } = invoiceSlice.actions;

export default invoiceSlice.reducer;
